import { useIsStaff } from '@vimeo/core/hooks/use-is-staff/useIsStaff';
import { shouldShowInDevelopmentFeature } from '@vimeo/query-feature-flag';

import { isCI } from '../utils/helper';

/**
 * Custom hook to determine if a feature flag for testing is enabled.
 * @returns {boolean} - True if the feature flag is enabled.
 */
export const useFeatureFlag = (
  queryFlag: string,
  staffOnly = true,
  checkLocalStorage = true,
): boolean => {
  const isCIEnv = isCI();
  let isStaff = useIsStaff();
  if (isCIEnv) {
    isStaff = true;
  }
  const shouldShowDevFeature = shouldShowInDevelopmentFeature(queryFlag, checkLocalStorage);
  return shouldShowDevFeature && (staffOnly ? isStaff : true);
};
